module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      ref: "funnel-chart-animator",
      staticClass: "funnel-chart-animator"
    }, [_c('div', {
      key: _vm.key,
      staticClass: "funnel-chart"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.conversion_funnel.label')))]), _vm._v(" "), _c('div', {
      staticClass: "row gutter-sm"
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('div', {
      staticClass: "chart-data"
    }, [_c('div', {
      staticClass: "chart-funnel"
    }, _vm._l((_vm.chartSegments), function(segment, index) {
      return _c('div', {
        key: ("segment" + index),
        staticClass: "funnel-segment"
      }, [(index > 0) ? _c('div', {
        staticClass: "segment-spacer"
      }) : _vm._e(), _vm._v(" "), _c('svg', {
        staticStyle: {
          "border-radius": "4px"
        },
        attrs: {
          "viewBox": "0 0 100 100",
          "preserveAspectRatio": "none"
        }
      }, [_c('defs', [_c('linearGradient', {
        attrs: {
          "id": ("grad" + index),
          "x1": "0%",
          "y1": "0%",
          "x2": "0%",
          "y2": "100%"
        }
      }, [_c('stop', {
        style: (("stop-color: " + (_vm.segmentColors[index]))),
        attrs: {
          "offset": "0%"
        }
      }), _vm._v(" "), _c('stop', {
        style: (("stop-color: " + ((_vm.segmentColors[index])))),
        attrs: {
          "offset": "100%"
        }
      })], 1)], 1), _vm._v(" "), _c('polygon', {
        attrs: {
          "points": "",
          "fill": _vm.isGradientColors ? ("url(#grad" + index) : _vm.segmentColors[index]
        }
      }, [_c('animate', {
        attrs: {
          "attributeName": "points",
          "dur": _vm.isAnimated ? _vm.animationTime : '0.015s',
          "fill": "freeze",
          "from": '0,0 100,0 100,100 0,100',
          "keySplines": "\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1",
          "keyTimes": "0;0.22;0.33;0.55;0.66;0.88;1",
          "calcMode": "spline",
          "to": ("\n                        " + ((100 - segment.conversion)) + ",0\n                        100,0\n                        100,100\n                        " + ((_vm.chartSegments[index + 1] ? (100 - _vm.chartSegments[index + 1].conversion) : '100')) + ",100")
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "segment-text"
      }, [_c('p', {
        staticClass: "accent pre"
      }, [_vm._v(_vm._s(segment.value))]), _vm._v(" "), _c('p', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(segment.label))])])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "acumulative-panel"
    }, _vm._l((_vm.chartSegments), function(step, index) {
      return (index > 0) ? _c('div', {
        key: ("step-" + index),
        class: ("data-" + index)
      }, [_c('h4', [_vm._v(_vm._s(_vm._f("percentage")(step.conversion)))])]) : _vm._e()
    }), 0)])])])])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3933581a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/ConversionFunnelWidget.vue
// module id = 1871
// module chunks = 0